var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.classe1 , _vm.col]},[_c('label',[_vm._v(_vm._s(_vm.nome))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }